export class NonOptimizedBrowserMessage {
  private showMessage = true;

  constructor() {}

  private dismissMessage(): void {
    this.showMessage = false;
  }
}

angular
  .module('capability-ng-global')
  .controller('ngNonOptimizedBrowserMessage', NonOptimizedBrowserMessage)
  .component('nonOptimizedBrowserMessage', {
    controller: 'ngNonOptimizedBrowserMessage',
    templateUrl: 'lib/global/components/non_optimized_browser_message/non_optimized_browser_message.html',
    controllerAs: '$ctrl'
  });



// WEBPACK FOOTER //
// ./app/lib/global/components/non_optimized_browser_message/non_optimized_browser_message.ts